import React from 'react';

const Tag = (props) => (
    <li {...props} className={`tag ${props.className}`}>{`# ${props.children}`}</li>
)

export default Tag;